var render = function render(){var _vm=this,_c=_vm._self._c;return _c(this.$route.meta.layout || 'div',{key:'comp_' + (this.$route.meta.layout || 'div'),tag:"component"},[_c('transition',{attrs:{"name":"page","mode":"out-in","appear":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }